import Vue from 'vue'

export default Vue.extend({})



// WEBPACK FOOTER //
// ./app/App.ts